import { Stack, Tab, Tabs, Typography } from "@mui/material"
import moment from "moment"
import Avatar from "../../Tools/Avatar"
import { useLocation, useNavigate } from "react-router-dom"
import { Handshake, Person } from "@mui/icons-material"
import { txt } from "../../../services/translation"

export default function Top({user}){

    const navigate = useNavigate()
    const {pathname} = useLocation()

    const tabs = ['/profile', '/sponsor']

    return (
        <Stack spacing={1.5}>
    
            <Stack direction='row' spacing={3} alignItems='center'>
    
                <Avatar
                    initials={user.initials}
                    color={user.category?.color}
                    size={60}
                />
    
                <Stack spacing={0.5}>
                    <Typography variant='h1'>{user.name}</Typography>
    
                    <Typography variant='small' sx={{color: 'grey'}}>
                        {txt('accountCreatedOn')} {moment(user.createdAt).format('L')}
                    </Typography>
                    
                </Stack>
    
            </Stack>
    
            {tabs.includes(pathname) && 
                <Tabs value={pathname} onChange={(e,v) => navigate(v)}>
                    <Tab label={txt('myProfile')} value="/profile" icon={<Person />} iconPosition="start" />
                    <Tab label={txt('sponsorship')} value="/sponsor" icon={<Handshake />} iconPosition="start"/>
                </Tabs>
            }
    
        </Stack>
    );
    
}